<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton title :row="20" :loading="loadingPage">
      <div v-for="(type,index) in typeList" :key="index" class="typeRect">
        <div v-if="!type.isHide" class="title">
          {{ type.name }}
          <span v-if="type.type==='Coach'">教练</span>
          <span v-if="type.type==='DivePlace'">潜点</span>
          <span v-if="type.type==='Course'">行程/课程</span>
          <div v-if="!type.isAwaysOpen" class="moreButton" @click="onOpenInfo(index)">
            {{ postData[index].isOpen?'收起':'更多' }}
          </div>

        </div>
        <div v-if="!type.isHide" class="LineRectImg">
          <div class="LeftRect">
            <van-image
              width="4em"
              height="4em"
              fit="cover"
              :src="type.icon?type.icon:'/img/defaultIcon.jpg'"
            />
          </div>
          <div class="CenterRect">
            <van-rate v-model="postData[index].score" size="1.5em" :color="GetDiveMainBack()" />
          </div>
          <div class="RigthRect" :style="'color:'+GetDiveMainBack()">
            {{ getScoreText(postData[index].score) }}
          </div>
        </div>
        <template v-if="!type.isHide&& postData[index].isOpen">
          <div v-for="(config,indexConfig) in type.configList" :key="indexConfig" class="LineRect">
            <template v-if="config.commentType==='SOCRE'">
              <div class="LeftRect">
                {{ config.name }}
              </div>
              <div class="CenterRect">
                <van-rate v-model="postData[index].scoreList[indexConfig].score" size="1.5em" :color="GetDiveMainBack()" />
                <div class="tagButtonRects">
                  <template v-for="tag in config.tagNices">
                    <div
                      v-if="config.tagNiceType==='NORMAL' || (config.tagNiceType==='AUTO' && postData[index].scoreList[indexConfig].score >4)"
                      :key="tag"
                      class="tagButton"
                      :style="checkInTag(postData[index].scoreList[indexConfig].tag,tag)?'color:'+GetDiveMainBack()+';  border-color:'+GetDiveMainBack()+';':''"
                      @click="addTag(index,indexConfig,tag)"
                    >
                      {{ tag }}
                    </div>
                  </template>
                  <template v-for="tag in config.tagBadlys">
                    <div
                      v-if="config.tagBadlyType==='NORMAL' || (config.tagBadlyType==='AUTO' && postData[index].scoreList[indexConfig].score <=4)"
                      :key="tag"
                      class="tagButton"
                      :style="checkInTag(postData[index].scoreList[indexConfig].tag,tag)?'color:'+GetDiveMainBack()+';  border-color:'+GetDiveMainBack()+';':''"
                      @click="addTag(index,indexConfig,tag)"
                    >
                      {{ tag }}
                    </div>
                  </template>
                </div>
              </div>
              <div class="RigthRect" :style="'color:'+GetDiveMainBack()">
                {{ getScoreText(postData[index].scoreList[indexConfig].score) }}
              </div>
            </template>
            <template v-if="config.commentType==='YESNO'">
              <div class="LeftRect">
                {{ config.name }}
              </div>
              <div class="CenterRect">
                <van-switch v-model="postData[index].scoreList[indexConfig].scoreBoolean" size="1.5em" />
                <div class="aboutBoolean">{{ config.about }}</div>
              </div>
              <div class="RigthRect" :style="'color:'+GetDiveMainBack()">
                {{ postData[index].scoreList[indexConfig].scoreBoolean?'是':'否' }}
              </div>
            </template>
          </div>

          <div class="LineRect">
            <div class="LeftRect">
              评语
            </div>
            <div class="CenterRect">
              <van-field
                v-model="postData[index].about"
                rows="3"
                autosize
                type="textarea"
                placeholder="请输入点评意见,这对我们很重要!"
                style="background-color:#f5f5f5"
              />
              <van-uploader
                v-model="postData[index].fileList"
                class="imageUpload"
                multiple
                :max-count="20"
                :after-read="afterRead"
                preview-size="60px"
              />
            </div>
          </div>
        </template>
      </div>
    </van-skeleton>
    <div class="emptyRect" />
    <div class="buttonRect">
      <van-row gutter="10">
        <van-col span="12"><van-button :color="GetColorSecondary()" size="small" style="width:100%" :loading="buttonLoading" @click="onSubject(true)">匿名提交</van-button></van-col>
        <van-col span="12"><van-button :color="GetDiveMainBack()" size="small" style="width:100%" :loading="buttonLoading" @click="onSubject(false)">提交</van-button></van-col>
      </van-row>

    </div>

  </div>
</template>
<script>
import request from '@/utils/request'
import { getDiveCommentConfigList } from '@/utils/baseData'
import { Button, Image, Rate, Field, Uploader, Skeleton, Dialog, Switch } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, getScoreText, MyNotify, ShowMoney, GetEnumText, formatDate, compressorImageList } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Rate.name]: Rate,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Skeleton.name]: Skeleton,
    [Dialog.name]: Dialog,
    [Switch.name]: Switch,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '评论行程',
      backurl: '/dive',
      studentId: undefined,
      loadingPage: true,
      buttonLoading: false,
      value: 5,
      message: '',
      classId: undefined,
      fileList: [],
      configList: [],
      fullScore: 5,
      typeList: [],
      postData: [
        {
          isOpen: true,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        },
        {
          isOpen: false,
          score: 5,
          scoreList: [
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] },
            { location: '', score: 5, scoreBoolean: true, tag: [] }
          ],
          about: '',
          res: '',
          fileList: []
        }

      ]
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.studentId = this.$route.params.id
    if (this.studentId === '0') {
      this.classId = getUrlKey('classid')
    } else {
      this.classId = undefined
    }
    getDiveCommentConfigList((data) => {
      this.configList = data

      this.init()
    })
  },
  methods: {
    getScoreText,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    onSubject(isAnonymous) {
      if (this.postData.length <= 0) {
        return
      }
      this.buttonLoading = true
      var i = 0
      this.postImg(i, () => {
        var postData = []
        for (var j = 0; j < this.postData.length && j < this.typeList.length; j++) {
          var type = this.typeList[j]
          var data = this.postData[j]
          var one = {
            type: type.type,
            id: type.id,
            studentId: this.studentId,
            about: data.about,
            res: data.res,
            isAnonymous: isAnonymous,
            score: data.score,
            scoreList: []
          }
          data.scoreList.forEach(item => {
            if (item.location !== '') {
              var score = 5
              if (item.commentType === 'SOCRE') {
                score = item.score
              } else if (item.commentType === 'YESNO') {
                score = item.scoreBoolean ? 5 : 1
              }
              one.scoreList.push({
                tag: item.tag.join(','),
                score: score,
                location: item.location
              })
            }
          })
          postData.push(one)
        }
        request({
          url: '/DiveData/AddDiveCommnet',
          method: 'post',
          data: postData
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '评价成功')
          this.$router.push('/divetrip/trip/' + this.studentId)
        })
      })
    },
    postImg(i, callback) {
      if (i >= this.postData.length) {
        if (callback) {
          callback()
        }
        return
      }
      this.uploadImg(this.postData[i].fileList, (urls) => {
        this.postData[i].res = urls
        this.postImg(i + 1, callback)
      })
    },
    afterRead(file) {
      console.log('file', file)
    },
    uploadImg(files, callback) {
      var noFile = true
      var fileList = []
      files.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback('')
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=divecomment',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    },
    init() {
      request({
        url: '/DiveData/getStudentCommentTypleList',
        method: 'post',
        data: { studentId: this.studentId,
          classId: this.classId }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (response.data.commentId) {
          Dialog.confirm({
            title: '已进行评分',
            message: '已经进行了评分,是否查看评分?',
            confirmButtonText: '查看',
            cancelButtonText: '返回'
          }).then(() => {
            this.$router.push('/divetrip/tripCommentView/' + response.data.studentId)
          }).catch(() => {
            this.$router.push('/my/index')
          })
          return
        }
        this.typeList = response.data.list
        this.studentId = response.data.studentId
        var i = 0
        this.typeList.forEach(item => {
          var j = 0
          item.configList = this.configList.filter(config => config.type === item.type)
          item.isOpen = item.isAwaysOpen
          if (this.typeList.length === 1) {
            item.isOpen = true
            item.isAwaysOpen = true
          }
          this.postData[i].isOpen = item.isOpen
          item.configList.forEach(config => {
            this.postData[i].scoreList[j].location = config.location
            this.postData[i].scoreList[j].commentType = config.commentType
            j++
          })
          i++
        })
        this.loadingPage = false
        console.log('typeList', this.typeList)
        console.log('postData', this.postData)
      })
    },
    checkInTag(list, tag) {
      return list.filter(item => item === tag).length > 0
    },
    addTag(index, indexConfig, tag) {
      var list = this.postData[index].scoreList[indexConfig].tag
      var have = this.checkInTag(list, tag)
      if (have) {
        this.postData[index].scoreList[indexConfig].tag = list.filter(item => item !== tag)
      } else {
        this.postData[index].scoreList[indexConfig].tag.push(tag)
      }
    },

    onOpenInfo(index) {
      console.log('onOpenInfo')
      this.postData[index].isOpen = !this.postData[index].isOpen
    }
  }
}
</script>
<style scoped>
.typeRect
{
    background-color: #fff;
    padding: 0 1em;
    margin-bottom: 0.5em;
}
.typeRect .title{
    font-weight: 700;
    padding: 1em 0;
    position: relative;
    border-bottom: 1px solid #f5f5f5;

}
.typeRect .title .moreButton
{
    position: absolute;
    right: 0em;
    top: 1em;
    font-weight: normal;
    font-size: 0.8em;
    color: #999;
    line-height: 2em;
}

.LineRectImg{
    position: relative;
    padding: 1em 0;
    border-bottom: 1px solid #f5f5f5;
}
.LineRectImg .LeftRect{
    position: absolute;
    left: 0em;
}
.LineRectImg .CenterRect{
    margin-left: 5em;
    padding: 1.1em 0;
}
.LineRectImg .RigthRect{
    position: absolute;
    right: 0em;
    top: 1em;
    line-height: 4.5em;
    font-weight: 700;
    text-align: right;
    font-size: 0.9em;
}

.LineRect{
    position: relative;
    padding: 0.5em 0;
}
.LineRect .LeftRect{
    position: absolute;
    left: 0em;
    text-align: center;
    width: 4em;
    font-weight: 700;
    font-size: 0.9em;
    line-height: 2em;
}
.LineRect .CenterRect{
    margin-left: 5em;
}
.LineRect .RigthRect{
    position: absolute;
    right: 0em;
    top: 0.5em;
    font-weight: 700;
    text-align: right;
    font-size: 0.9em;
    line-height: 2em;
}
.tagButtonRects{
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.5em;
}
.tagButtonRects .tagButton{
    margin-right: 0.5em;
    margin-bottom: 0.5em;
    border-radius: 0.4em;
    border: 2px solid #e2e2e2;
    background-color: #E2E2E2;

    color: #707070;
    font-size: 0.7em;
    padding: 0.25em 0.5em;
}
.emptyRect{
    height: 3em;
}
.buttonRect
{
    background-color: #fff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3em;
    border-top: 1px solid #f5f5f5;
    padding: 1em 1em 0 1em;
}
.imageUpload{
  margin-top: 0.5em;
}
.aboutBoolean{
  color:#999;
  font-size: 0.8em;
}
</style>
